export default __webpack_public_path__ + "static/media/caregiver-assisting-senior-man-out-of-bed.4e7187ab.jpg";